import { render, staticRenderFns } from "./Extraordinario.vue?vue&type=template&id=28ee9266&"
import script from "./Extraordinario.vue?vue&type=script&lang=ts&"
export * from "./Extraordinario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports